<template>
  <div class="box territory scroll clear" style="height:calc(100% - 36px)">
    <div class="left">
      <div class="seach">
        <el-input @change="selectClose" style="width: 100%; height: 32px; margin: 0 10px 0px 10px;"
          placeholder="信息监测方案模糊搜索" v-model="seach.value2" clearable>
          <template slot="append">
            <el-button style="width: -webkit-fill-available; color: #2e59ec" type="text"
              @click="getListInof">搜索</el-button>
          </template>
        </el-input>
      </div>
      <div v-if="this.monitorData.length != 0" class="left-monitoring">
        <div v-for="item in monitorData" :key="item.id + item.schemeName" v-loading="monitorDataLoading"
          @click="selectMonitor(item, 1)" :class="{ content: true, contentshad: defaultId == item.monitorId }">
          <div class="content-top">
            <div class="content-top-left">{{ item.schemeName || '' }}</div>
          </div>
          <div style="margin-bottom: 14px" class="content-content">
            <div class="content-content-stop" style="color: #ff8000" v-if="item.status == '0'">
              <img src="../../assets/img/views/tingzhi.png" alt />
              已停止
            </div>
            <div class="content-content-function" v-else-if="item.status == '1'">
              <img src="../../assets/img/views/yunxing.png" alt />
              运行中
            </div>
            <div style="width: 210px;color: #ea3342;font-size: 14px;">
              管理员创建，联系管理员进行维护
            </div>
          </div>
        </div>
      </div>
      <div v-else class="left-empty-text">
        暂无信息监测方案，请联系管理员进行创建
      </div>
    </div>
    <div v-if="this.monitorData.length != 0" class="right">
      <div class="right-top">
        <div class="right-top-top">
          <div class="right-top-top-left">
            {{ rightview.schemeName }}
            <span>（{{ allTotal }}条 ）</span>
          </div>
          <div class="right-top-top-right">
            <div v-if="rightview.status == '0'" style="cursor: pointer; color: #ff8000">
              <img src="../../assets/img/views/tingzhi.png" alt />
              已停止
            </div>
            <div v-else style="cursor: pointer">
              <img src="../../assets/img/views/yunxing2.png" alt />
              运行中
            </div>
          </div>
        </div>
        <div class="right-top-bottom">
          <div>创建时间：{{ rightview.createTime }}</div>
          <div style="margin-left: 120px">
            最后编辑时间：{{ rightview.updateTime }}
          </div>
        </div>
      </div>
      <div class="right-contnet">
        <div class="right-contnet-checkbox">
          <span>数据调性</span>
          <el-checkbox v-model="tonalStateAll" @change="tonalStateAllChange">全部</el-checkbox>
          <el-checkbox-group v-model="seach.tonalState" @change="tonalStateChange">
            <el-checkbox :label="0">正面</el-checkbox>
            <el-checkbox :label="1">中性</el-checkbox>
            <el-checkbox :label="2">负面</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="right-contnet-checkbox">
          <span>数据范围</span>
          <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全部</el-checkbox>
          <el-checkbox-group v-model="seach.mediaLink" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="city in cities" :label="city" :key="city">
              {{ city }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="right-contnet-checkbox">
          <span>媒体级别</span>
          <el-checkbox v-model="levelAll" @change="levelAllChange">全部</el-checkbox>
          <el-checkbox-group v-model="seach.mediaLevel" @change="levelStateChange">
            <el-checkbox v-for="(city, index) in mediaLevelList" :label="city" :key="index">
              {{ city }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="right-contnet-checkbox">
          <InputGroupVue ref="InputGroupVue" />
        </div>
        <div class="right-contnet-seach">
          <div class="right-contnet-seach-left">
            <span class="el_font">时间</span>
            <el-date-picker v-model="timer[0]" type="date" style="width: 150px" @change="timeChange($event, 1)"
              value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            -
            <el-date-picker v-model="timer[1]" type="date" style="width: 150px" @change="timeChange($event, 2)"
              value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
            <el-checkbox style="margin-left: 32px" v-model="isWarn" :true-label="1" :false-label="0">已预警</el-checkbox>
            <el-checkbox style="margin-left: 32px" v-model="isHistory" :true-label="0"
              :false-label="1">隐藏历史数据</el-checkbox>
            <el-checkbox style="margin-left: 32px" v-model="isRepeat" :true-label="0"
              :false-label="1">隐藏重复数据</el-checkbox>
          </div>
          <div class="right-contnet-seach-right">
            <el-button type="primary" @click="searchList">查询</el-button>
            <el-button plain @click="resetting">重置</el-button>
          </div>
        </div>
        <div v-if="textData && textData.length > 0" class="right-contnet-content" v-loading="loading">
          <template>
            <div class="right-contnet-content-button">
              <div style="float: left">
                <el-checkbox v-model="checkAll6" @change="handleCheckAllChange6">全选</el-checkbox>
              </div>
              <el-button class="export" :disabled="suspend" :class="suspend ? 'prohibit' : ''" size="small"
                @click="exportAllData">
                数据导出
              </el-button>
              <el-button class="delete" size="small" @click="deletes(1)">批量删除</el-button>
              <el-button class="copy" size="small" @click="AllCopy">批量复制</el-button>

              <!-- 精简按钮 || 列表按钮  -->
              <el-radio-group class="M-L" v-model="radioValue" size="medium" @change="changeradio">
                <el-radio-button label="1">
                  <img v-if="radioValue == '2'" height="13px" src="../../assets/img/views/jinjianBlack.png" alt="" />
                  <img v-else height="13px" src="../../assets/img/views/jinjian.png" alt="" />
                  <span v-if="radioValue == '2'" style="color: #666; font-size: 15px; margin-left: 4px">精简</span>
                  <span v-else style="color: #fff; font-size: 15px; margin-left: 4px">精简</span>
                </el-radio-button>
                <el-radio-button label="2">
                  <img v-if="radioValue == 2" height="13px" src="../../assets/img/views/liebiao.png" alt="" />
                  <img v-else height="13px" src="../../assets/img/views/liebiaoBlack.png" alt="" />
                  <span v-if="radioValue == '1'" style="color: #666; font-size: 15px; margin-left: 4px">列表</span>
                  <span v-else style="color: #fff; font-size: 15px; margin-left: 4px">列表</span>
                </el-radio-button>
              </el-radio-group>
            </div>
            <div v-for="(item, inx) in textData" :key="inx" class="right-contnet-content-div">
              <!-- 列表  && 精简-->
              <div class="right-contnet-content-div-title">
                <div class="right-contnet-content-div-title-left" :style="{ width: radioValue == 1 ? '80%' : '100%' }">
                  <div class="title-item-left">
                    <el-checkbox-group v-model="checkedCities6" @change="handleCheckedCitiesChange6">
                      <el-checkbox :label="item.id">{{ "" }}</el-checkbox>
                    </el-checkbox-group>
                    <div
                      :class="['type', item.tonalState == 2 ? 'red' : item.tonalState == 1 ? 'neutral' : 'obverse',]">
                      {{ item.tonalState == 2 ? "负面" : item.tonalState == 0 ? "正面" : "中性" }}
                    </div>
                    <span v-if="item.isHistory == 1" class="comment-box-yujing history-style"
                      style="min-width: 76px;">历史数据</span>
                    <span v-if="item.isRepeat == 1" class="comment-box-yujing repeat-style"
                      style="min-width: 76px;">重复数据</span>
                    <span v-if="item.isWarn == 1" class="comment-box-yujing" style="min-width: 62px;">已预警</span>
                    <span class="mediaLink" v-if="item.mediaLink" style="min-width: 90px;margin-left: 16px;">{{
                      item.mediaLink }}</span>

                    <h1 v-html="item.title ? item.title : ''" @click="goDetail(item)"
                      :style="{ width: radioValue == 1 ? '67%' : '56%' }"></h1>
                  </div>
                  <span class="original" @click="lookOriginal(item.sourceUrl)">
                    <span>
                      <img src="../../assets/img/views/wenzhang.png" alt />
                    </span>
                    <span>查看原文</span>
                  </span>
                </div>
                <div style="display: flex;align-items: center;font-size: 14px;color: #888;width: 150px;"
                  v-if="radioValue == 1">
                  {{ item.publishTime }}
                </div>
              </div>
              <template v-if="radioValue == 2">
                <div class="right-contnet-content-div-content" v-html="item.abstracts" @click="goDetail(item)"></div>
                <div class="right-contnet-content-div-tag">
                  <div>
                    <div>
                      作者ID：{{ item.authorId ? item.authorId : "无" }}
                    </div>
                    <div>
                      来源/作者：{{ (item.source ? item.source : "无") + (item.author ? "/" + item.author : "/" + "无") }}
                    </div>
                    <div>分类：{{ item.aiClass }}</div>
                    <div>媒体级别：{{ item.mediaLevel }}</div>
                    <!-- <span class="publics bottom-key">
                      关键字:
                      <span v-if="item.keyword">
                        <span v-for="(ite, indx) in item.keywordList"
                          :class="[ite != item.keywordList[item.keywordList.length - 1] ? 'styleMargin' : '',]"
                          :key="indx">
                          {{ ite }}
                        </span>
                      </span>
                      <span v-else>无</span>
                      <el-tooltip v-if="item.keyword && item.keywordArry.length > 3" class="item" effect="dark"
                        placement="top">
                        <div slot="content" v-html="item.keyword"></div>
                        <span class="gengduo-link">(更多)</span>
                      </el-tooltip>
                    </span> -->
                  </div>
                  <div>{{ item.publishTime }}</div>
                </div>
                <div class="right-contnet-content-div-img">
                  <el-image v-for="(x, inx) in item.thumbnail" :key="inx"
                    style="width: 72px; height: 64px; margin: 15px 15px 0 0" :src="x"
                    :preview-src-list="item.thumbnail">
                    <div slot="error" class="image-slot">
                      <img src="../../assets/img/views/img.png" style="width: 72px; height: 64px" />
                    </div>
                  </el-image>
                </div>
                <div class="right-contnet-content-div-operation">
                  <div class="right-contnet-content-div-operation-right">
                    <div @click="myCopy(item)">
                      <img src="../../assets/img/views/monitoringScheme/fuzhi.png" alt />
                      复制全部
                    </div>
                    <div @click="quickCopy(item)">
                      <span style="margin: 0; color: black; font-size: 16px" class="el-icon-link"></span>
                      复制链接和标题
                    </div>
                    <div v-if="!rightview.pmonitorId && !rightview.dataSourceId" @click="deletes(2, item)">
                      <img src="../../assets/img/views/monitoringScheme/shanchu3.png" alt />
                      删除
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
        <div class="analyse-container" style="height: 200px" v-else>
          <div class="analyse-container-img">
            <img src="../../assets/img/views/analyse-img.png" />
            <p>暂无数据</p>
          </div>
        </div>
        <div class="block">
          <span class="total">
            共{{ tablePage.total }}条, 当前显示第{{
              tablePage.page * tablePage.pageSize - tablePage.pageSize + 1
            }}-{{
              tablePage.page * tablePage.pageSize > tablePage.total
                ? tablePage.total
                : tablePage.page * tablePage.pageSize
            }}条
          </span>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tablePage.page" :page-sizes="tablePage.pageSizes" :page-size="tablePage.pageSize"
            layout="sizes, prev, pager, next,jumper" :total="tablePage.total"></el-pagination>
        </div>
      </div>
    </div>
    <deleteDialog ref="openDialog" @deleteFn="deleteFn" />
  </div>
</template>

<script>
import InputGroupVue from './components/InputGroup.vue';
import fackClickOutSide from "@/utils/fackClickOutSide";
import { downloadFile } from '@/utils/file'
import {
  getPageList,
  schemeDataList,
  getDataById,
  getTotal,
  exportData,
  batchDel
} from "../../api/infoMonitor/index";
import deleteDialog from "../../components/deleteDialog";
export default {
  mixins: [fackClickOutSide],
  data() {
    return {
      deleteId: '',
      monitorDataLoading: false,
      planId: '',
      schemeId: '',
      sjSchemeId:'',
      idType:'', 
      sjMonitorType:'',
      queryExportData: {},
      //自定义预警 调性
      tonalityList: [
        { value: "0", name: "正面" },
        { value: "1", name: "中性" },
        { value: "2", name: "负面" },
      ],
      tonality: [],
      radioValue: 2, // 精简1 || 列表2
      isWarn: 0, //是否已预警
      isHistory: 1, //是否已预警
      isRepeat: 1, //是否已预警
      noData: false,
      defaultId: sessionStorage.getItem("defaultId")
        ? sessionStorage.getItem("defaultId")
        : null, //默认id
      loading: false, // 加载动画  数据列表
      monitorId: null, // 全局的方案ID
      //数据列表 多选框
      checkAll6: false,
      checkedCities6: [],
      timer: [], // 查询的时间
      rightview: {}, // 右边头部的信息展示  方案信息
      textData: [], //数据列表
      seach: {
        mediaLink: [], // 媒体环节
        value2: "", // 监测方案模糊查询
        publishTimeStart: "", // 开始时间
        publishTimeEnd: "", // 结束时间
        tonalState: [], //舆情调性选项
        mediaLevel: []
      },
      // 媒体环节
      checkAll: false,
      cities: ['电视', '纸媒', '网站', '微博', '微信公众号', '移动客户端', '互动栏目'],
      mediaLevelList: ['央级', '省级', '市级', '区县级', '其他'],
      // 分页
      tablePage: {
        pageSizes: [10, 20, 30, 40, 50],
        page: 1,
        pageSize: 10,
        total: 0,
      },
      monitorData: [], // 机构方案
      allTotal: 0,
      saveSearch: {},
      suspend: false,
      tonalStateAll: false, //舆情调性全选
      levelAll: false, //舆情调性全选
    };
  },
  props: {
    jumpData: {
      type: Object,
    },
  },
  components: {
    deleteDialog, InputGroupVue
  },
  watch: {

  },
  methods: {
    /*  定向监测  自定义预警 结束*/
    lookOriginal(web) {
      window.open(web);
    },
    // 用Promise 封装setTimeout
    setTimeout: (time) => new Promise((res) => setTimeout(res, time)),
    // 精简 || 列表
    async changeradio() {
      this.loading = true;
      await this.setTimeout(300);
      this.loading = false;
    },
    selectClose() {
      if (!this.seach.value2) {
        this.getListInof();
      }
    },
    handleCheckAllChange(val) {
      this.seach.mediaLink = val ? this.cities : [];
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
    },
    handleCheckAllChange6(val) {
      this.checkedCities6 = val ? this.textData.map(item=>item.id) : [];
    },
    handleCheckedCitiesChange6(value) {
      let checkedCount = value.length;
      this.checkAll6 = checkedCount === this.textData.length;
    },
    // 删除监测方案弹框  type 1.表示方案  2，表示关键字组  3.表示定向检测   4.数据列表删除 5.批量删除
    deletes(type, currentItem) {
      let item = {
        message: "方案数据",
        type,
      };
      if (type == 2) {
        this.deleteId = currentItem.id;
      }
      this.$refs.openDialog.openDialog(item);
    },
    // 删除监测方案
    async deleteFn(data) {
      // 批量删除
      if (data.type == 1) {
        console.log('批量删除',this.checkedCities6);
        let res = await batchDel({
          ids: this.checkedCities6,
          idType: this.idType,
          sjMonitorType: this.sjMonitorType,
          schemeId: this.schemeId,
          sjSchemeId: this.sjSchemeId,
        });
        if (res.data.code == 0) {
          this.$message({
            message: '删除成功',
            type: 'success',
          });
          this.checkedCities6 = [];
          this.getSchemeDataList()
          this.getListTotal()
        }
      } else {
        // 删除单个
        let res = await batchDel({
          ids: [this.deleteId],
          idType: this.idType,
          sjMonitorType: this.sjMonitorType,
          schemeId: this.schemeId,
          sjSchemeId: this.sjSchemeId,
        });
        if (res.data.code == 0) {
          this.$message({
            message: '删除成功',
            type: 'success',
          });
          this.deleteId = '';
          this.getSchemeDataList()
          this.getListTotal()
        }
      }
    },
    // 获取数据
    async getListInof() {
      try {
        this.monitorDataLoading = true;
        const res = await getPageList({
          pageNum: 1,
          pageSize: 1000,
          searchName: this.seach.value2,
          sjOrgId: this.$store.state.user.organizationId,
          idTypeList: [1, 2]
        });
        if (res.data.code == 0) {
          this.monitorData = res.data.data.records;
        }
      } catch (error) {
        console.log(error);
        this.$message({
          message: '获取列表失败',
          type: 'warning',
        });
      } finally {
        this.monitorDataLoading = false;
      }
    },
    // 分页
    handleSizeChange(val) {
      this.checkAll6 = false;
      this.tablePage.pageSize = val;
      this.tablePage.page = 1;
      this.getSchemeDataList(this.rightview);
      window.scrollTo(0, 0);
    },
    // 点击页码跳转
    handleCurrentChange(val) {
      this.checkAll6 = false;
      this.tablePage.page = val;
      this.getSchemeDataList(this.rightview);
      window.scrollTo(0, 100);
    },
    // 右边的头部信息
    async getTopInof() {

    },
    // 数据导出
    async exportAllData() {
      try {
        this.suspend = true
        let res = await exportData({
          ...this.queryExportData,
          schemeName: this.rightview.schemeName,
          idType: this.idType,
          sjMonitorType: this.sjMonitorType,
          sjSchemeId: this.sjSchemeId,
        });
        this.$parent?.$parent?.timeDreFresh?.();
        downloadFile(res.data, `${this.rightview.schemeName}.xlsx`);
      } catch (error) {
        console.log(error);
      } finally {
        this.suspend = false
      }
    },
    // 点击左边的方案列表切换右边的方案数据
    selectMonitor(item) {
      this.resetting(false)
      this.planId = item.id
      this.schemeId = item.schemeId
      this.sjSchemeId = item?.sjSchemeId ?? null
      this.idType = item?.idType ?? null
      this.sjMonitorType = item?.sjMonitorType ?? null
      this.getSchemeDataList()
      this.getDetail(this.planId);
      this.getListTotal()
    },
    async getListTotal() {
      let res = await getTotal({
        schemeId: this.schemeId,
        idType: this.idType,
        sjMonitorType: this.sjMonitorType,
        sjSchemeId: this.sjSchemeId,
      });
      this.allTotal = res.data.data;
    },
    //获取方案详情
    async getDetail(id) {
      const res = await getDataById(id);
      this.rightview = res.data.data;
    },
    async getSchemeDataList() {
       if (this.timer[0] && this.timer[1] && this.timer[0] > this.timer[1]) {
        this.$message.warning("请选择正确的时间段");
        return;
      }
      if (!this.timer[0] || !this.timer[1]) {
        this.timer = [];
      }
      //列表页
      const data = {
        pageNum: this.tablePage.page,
        pageSize: this.tablePage.pageSize,
        schemeId: this.schemeId,
        idType: this.idType,
        sjMonitorType: this.sjMonitorType,
        sjSchemeId: this.sjSchemeId,
        tonalState: this.seach.tonalState.join(','),
        mediaLink: this.seach.mediaLink.join(','),
        mediaLevel: this.seach.mediaLevel.join(','),
        ...this.$refs.InputGroupVue.getFromData(),
        // publishTimeStart: this.seach.publishTimeStart || '',
        // publishTimeEnd: this.seach.publishTimeEnd || '',
        isWarn: this.isWarn ? this.isWarn : null,
        isHistory: this.isHistory == 1 ? null : this.isHistory,
        isRepeat: this.isRepeat == 1 ? null : this.isRepeat,
      };
      if (this.timer[0] && this.timer[1] && this.timer[0] <= this.timer[1]) {
        data.publishTimeStart = this.seach.publishTimeStart;
        data.publishTimeEnd = this.seach.publishTimeEnd;
      } else {
        this.seach.publishTimeStart = "";
        this.seach.publishTimeEnd = "";
      }
      this.queryExportData = JSON.parse(JSON.stringify(data));
      this.loading = true;
      const res = await schemeDataList(data);
      if (res.data.code == 0) {
        this.textData = res.data?.data?.records || [];
        this.tablePage.total = res.data?.data?.total || 0;
        this.loading = false;
      }
    },
    // 个别复制
    myCopy(item) {
      let test = `标题：${item.title}\n链接：${item.sourceUrl}\n摘要：${item.content}\n时间：${item.publishTime}\n来源：${item.source}\n媒体：${item.mediaLink}\n作者：${item.author}\n`;
      this.$publicFun.copyFun(test);
    },
    //复制链接与标题
    quickCopy(msg) {
      let str = "";
      str = "标题：" + msg.title + "\n" + "链接：" + msg.sourceUrl;
      this.$publicFun.copyFun(str);
    },
    // 批量复制
    AllCopy() {
      if (this.checkedCities6.length > 0) {
        let text = '';
        let copyList = this.textData.filter((item) => this.checkedCities6.includes(item.id));
        copyList.forEach((item) => {
           text = `${text}标题：${item.title}\n链接：${item.sourceUrl}\n摘要：${item.content}\n时间：${item.publishTime}\n来源：${item.source}\n媒体：${item.mediaLink}\n作者：${item.author}\n`;
        });
        this.$publicFun.copyFun(text);
      } else {
        this.$message({
          message: "请先选择需要复制的数据",
        });
      }
    },
    // 点击检测数据进去详情页
    goDetail(item) {
      let routeUrl = this.$router.resolve({
        path: "/infoMonitor/index/detail",
        query: {
          info: encodeURIComponent(
            JSON.stringify({
              dataId: item.schemeId,
              monitorId: item.id,
              idType: this.idType,
              sjMonitorType: this.sjMonitorType,
              sjSchemeId: this.sjSchemeId,
            })
          ),
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 监测数据 搜索按钮
    searchList() {
      this.tablePage.page = 1;
      this.getSchemeDataList()
      this.getListTotal()
    },
    // 重置
    resetting(flag = true) {
      this.allTotal = 0
      this.isWarn = 0;
      this.isHistory = 1
      this.isRepeat = 1
      // 时间
      this.timer = [];
      this.checkAll6 = false;
      this.seach.publishTimeStart = "";
      this.seach.publishTimeEnd = "";
      this.$refs['InputGroupVue'].clearFromData()
      // 媒体环节
      this.checkAll = false;
      this.seach.mediaLink = [];
      this.seach.tonalState = [];
      this.seach.mediaLevel = [];
      this.levelAll = false;
      this.tonalStateAll = false;
      // 页码
      this.tablePage.page = 1;
      if (flag) {
        this.getSchemeDataList(this.rightview, 1);
        this.getListTotal()
      }
    },
    // 选择时间
    timeChange(val, type) {
      if (type == 1 && val) {
        this.seach.publishTimeStart = `${val} 00:00:00`;
      }
      if (type == 2 && val) {
        this.seach.publishTimeEnd = `${val} 23:59:59`;
      }
    },
    tonalStateAllChange(val) {
      this.seach.tonalState = val ? [0, 1, 2] : [];
    },
    levelAllChange(val) {
      this.seach.mediaLevel = val ? ['央级', '省级', '市级', '区县级', '其他'] : [];
    },
    tonalStateChange(value) {
      this.tonalStateAll = value.length === 3;
    },
    levelStateChange(value) {
      this.levelAll = value.length === 3;
    },
  },
  created() {
    this.getListInof();
  }
};
</script>

<style lang="scss" scoped>
.left-empty-text {
  text-align: center;
  color: rgb(234, 51, 66);
}
.territory {
  display: flex;
  justify-content: space-between;

  .right {
    margin-left: 16px;
  }
}

.M-L {
  margin-left: 10px;
}

::v-deep .el-radio-button--medium .el-radio-button__inner {
  padding: 6px 8px;
}

.box {
  .styleMargin {
    margin-right: 5px;
  }

  .gengduo-link {
    cursor: pointer;
    color: #2e59ec;
    margin-left: 5px;
  }

  .el_font {
    // margin-left: 32px;
    margin-right: 12px;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
  }

  .left {
    width: 423px;
    height: 100%;
    overflow-y: auto;
    background: #ffffff;
    border-radius: 8px;
    padding: 24px;
    position: relative;

    .seach {
      display: flex;
      height: 32px;
      margin-bottom: 24px;
    }

    .content {
      padding: 16px;
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      cursor: pointer;
      margin-bottom: 16px;

      .content-top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .content-top-left {
          max-width: 290px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 22px;
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }

        .content-top-right {
          width: 16px;
          height: 16px;
          cursor: pointer;
        }
      }

      .content-content {
        display: flex;
        align-items: center;
        margin-top: 24px;

        img {
          margin-right: 2px;
        }

        .content-content-delete {
          font-size: 14px;
          color: #ea3342;
          display: flex;
          align-items: center;
          margin-right: 40px;
          cursor: pointer;
        }

        .content-content-edit {
          font-size: 14px;
          color: #2e59ec;
          display: flex;
          align-items: center;
          margin-right: 40px;
          cursor: pointer;
        }

        .content-content-function {
          font-size: 14px;
          color: #02bc7c;
          display: flex;
          align-items: center;
          margin-right: 40px;
          cursor: pointer;
          min-width: 58px;
        }

        .content-content-stop {
          font-size: 14px;
          color: #ff9a16;
          display: flex;
          align-items: center;
          margin-right: 40px;
          cursor: pointer;
          min-width: 58px;
        }
      }

      .content-bottom {
        width: 100%;
        background: #f6f7fa;
        border-radius: 4px;
        padding: 16px;
        margin-top: 10px;
        box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
      }

      .contentshad2 {
        box-shadow: 0px 2px 5px 5px rgba(0, 0, 0, 0.08);
      }

      .content-bottom:hover {
        box-shadow: 0px 2px 5px 5px rgba(0, 0, 0, 0.14);
      }
    }

    .contentshad {
      box-shadow: 0px 2px 10px 10px rgba(0, 0, 0, 0.08);
    }

    .content:hover {
      box-shadow: 0px 2px 10px 10px rgba(0, 0, 0, 0.08);
    }

    .division {
      padding: 0 60px;

      ::v-deep .el-divider__text {
        font-size: 16px;
        color: #999999;
      }
    }

    .public {
      font-weight: 600;
      width: 100%;
      height: 70px;
      background: #ffffff;
      box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      cursor: pointer;

      div {
        font-size: 16px;
        color: #333333;
        padding-left: 16px;
      }
    }

    .contentshad3 {
      box-shadow: 0px 2px 10px 10px rgba(0, 0, 0, 0.08);
    }

    .public:hover {
      box-shadow: 0px 2px 10px 10px rgba(0, 0, 0, 0.08);
    }

    ::v-deep .el-button--primary {
      width: 100%;
      height: 36px;
      background: #13a8fd;
      border-radius: 4px;
      margin: 24px 0;
    }
  }

  .right {
    width: 73%;
    height: 100%;
    background-color: #fff;
    overflow-y: auto;

    .right-top {
      width: 100%;
      height: 121px;
      background-image: url("../../assets/img/views/bag.png");
      background-repeat: no-repeat;
      background-size: 100%;
      padding: 24px;

      .right-top-top {
        display: flex;
        justify-content: space-between;

        .right-top-top-left {
          font-size: 26px;
          font-weight: bold;
          color: #ffffff;

          span {
            font-size: 14px;
          }
        }

        .right-top-top-right {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: bold;
          color: #ffffff;

          div {
            margin-left: 32px;
            display: flex;
            align-items: center;

            img {
              margin-right: 3px;
            }
          }
        }
      }

      .right-top-bottom {
        margin-top: 16px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #ffffff;
      }
    }

    .right-contnet {
      width: 100%;
      background: #ffffff;
      border-radius: 8px;
      padding: 16px 0px;

      .right-contnet-checkbox {
        border-bottom: 1px solid #e4e6ec;
        padding: 0px 24px;
        padding-bottom: 16px;
        margin-top: 16px;
        display: flex;

        span {
          font-size: 14px;
          color: #999999;
          margin-right: 40px;
        }

        display: flex;
        align-items: center;

        ::v-deep .el-checkbox {
          margin-right: 25px;
          margin-bottom: 0;
        }
      }

      .right-contnet-seach {
        display: flex;
        justify-content: space-between;
        padding: 16px 24px;
        border-bottom: 1px solid #e4e6ec;

        .right-contnet-seach-left {
          display: flex;
          align-items: center;
        }

        .right-contnet-seach-right {
          ::v-deep .el-button {
            width: 60px;
            height: 32px;
            border-radius: 4px;
            padding: 0;
          }
        }
      }

      .right-contnet-content {
        min-height: 200px;

        .right-contnet-content-button {
          margin: 16px 0px;
          text-align: right;
          padding: 0px 24px;

          .delete {
            padding: 8px 15px;
            font-size: 14px;
            width: 88px;
            border: 1px solid #f7969e;
            color: #ea3342;
          }

          .copy {
            font-size: 14px;
            padding: 8px 15px;
            width: 88px;
            border: 1px solid #9cb0f6;
            color: #2e59ec;
          }

          .delete:focus,
          .delete:hover {
            background-color: #f7969e;
          }
        }

        .right-contnet-content-div {
          width: 100%;
          padding: 24px;
          border-bottom: 1px solid #e4e6ec;
          cursor: pointer;

          .right-contnet-content-div-title {
            display: flex;
            justify-content: space-between;

            .right-contnet-content-div-title-left {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .title-item-left {
                display: flex;
                align-items: center;
              }

              .mediaLink {
                height: 24px;
                background: #868bff;
                padding: 0 5px;
                font-size: 14px;
                font-weight: bold;
                color: #ffffff;
                line-height: 24px;
                text-align: center;
              }

              h1 {
                font-size: 18px;
                font-weight: bold;
                color: #333333;
                margin-left: 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 750px;
              }

              .original {
                width: 75px;
                display: flex;
                margin-left: 16px;
                cursor: pointer;
                font-size: 14px;
                color: #2e59ec;
              }

              .original span:nth-child(1) {
                margin-top: 2px;
                margin-right: 5px;
              }
            }
          }

          .right-contnet-content-div-content {
            width: 100%;
            font-size: 14px;
            max-height: 40px;
            color: #444;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            margin: 16px 0;
            line-height: 20px;
          }

          .right-contnet-content-div-tag {
            display: flex;
            align-items: center;
            justify-content: space-between;

            div {
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #888;

              div {
                margin-right: 24px;
              }
            }
          }

          .right-contnet-content-div-operation {
            display: flex;
            margin-top: 16px;
            justify-content: flex-end;

            .right-contnet-content-div-operation-right {
              display: flex;

              div {
                display: flex;
                align-items: center;
                margin-left: 40px;
                font-size: 14px;
                color: #333333;
                cursor: pointer;

                img {
                  margin-right: 8px;
                }
              }
            }
          }
        }

        .right-contnet-content-div:hover {
          box-shadow: 0px 2px 4px 4px rgba(0, 0, 0, 0.1);
        }

        .noData {
          width: 100%;
          height: 100%;
          text-align: center;
          line-height: 200px;
        }
      }

      .block {
        position: relative;
      }

      .block-count {
        position: absolute;
        top: 7px;
        font-size: 14px;
        color: #333333;
        left: 0;
      }

      .block .total {
        position: absolute;
        bottom: 5%;
        left: 9%;
        z-index: 11;
        font-size: 14px;
        display: inline-block;
        line-height: 32px;
        color: #999999;
      }
    }
  }

  .dialogcenter {
    .dialogcenter-top {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;

      li {
        width: 48%;
        margin-bottom: 24px;

        .dialogcenter-top-left {
          margin-bottom: 16px;
          font-size: 14px;
          font-weight: bold;
          color: #333333;
        }
      }
    }

    .dialogcenter-content {
      .dialogcenter-content-msg {
        width: 100%;
        height: 32px;
        display: flex;
        align-items: center;
        background: #fff8ef;
        border-radius: 4px;
        border: 1px solid #ffae45;
        font-size: 14px;
        color: #ffae45;

        img {
          margin: 0 8px;
        }
      }

      .dialogcenter-content-tab {
        width: 100%;
        // height: 40px;
        background: #f5f6fa;
        padding: 10px 16px;
        display: flex;
        align-items: center;

        .dialogcenter-content-tab-div {
          width: 588px;
          display: flex;
          align-items: center;

          p {
            margin-right: 40px;
            font-size: 14px;
            color: #333333;
          }
        }
      }

      .dialogcenter-content-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      li {
        width: 100%;
        margin-bottom: 24px;

        ::v-deep .el-checkbox {
          margin-right: 30px;
        }

        ::v-deep .el-divider__text {
          font-size: 16px;
          color: #999999;
        }

        .dialogcenter-content-left {
          margin-bottom: 16px;
          font-size: 14px;
          font-weight: bold;
          color: #333333;
        }

        .dialogcenter-content-div {
          width: 576px;
          margin-right: 12px;
          background: #f5f6fa;
          border-radius: 4px;
          display: flex;
          padding: 8px 16px;

          .dialogcenter-content-div-left {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            min-width: 60px;
            max-width: 200px;
          }

          .dialogcenter-content-div-right {
            margin-left: 40px;
            font-size: 14px;
            color: #333333;
            width: 300px;

            .dialogcenter-content-div-right-box {
              display: flex;
              width: 100%;
              line-height: 28px;

              span:nth-child(1) {
                height: 100%;
              }
            }
          }
        }

        .dialogcenter-content-right {
          display: flex;
        }
      }
    }
  }

  .redtext {
    color: red;
    margin: 0 3px 0 3px;
  }
}

.left-monitoring {
  min-height: 600px;
  padding: 10px;
}

.left-monitoring::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}

.left-monitoring::-webkit-scrollbar-thumb {
  border-radius: 10px;
  // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: rgba(0, 0, 0, 0.2);
}

.left-monitoring::-webkit-scrollbar-track {
  // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.analyse-container {
  width: 100%;
  height: 220px;
  background: #ffffff;
  border-radius: 4px;
  margin-top: 16px;
  text-align: center;
}

.analyse-container-img {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.analyse-container-img p {
  font-size: 14px;
  color: #999999;
}

.dialogcenter-content-font {
  margin-left: 10px;
}

.export {
  padding: 8px 15px;
  font-size: 14px;
  width: 88px;
  border: 1px solid #02bc7c;
  background: #f0fbf7;
  color: #02bc7c;
}

.analyse-container-box {
  margin-top: 0;
  float: right;
  width: 73%;
  height: 750px;
}

.numbox {
  position: relative;

  .loadingWiat {
    margin-left: 15px;
  }

  .numbox_search {
    min-width: 480px;
    height: 250px;
    background-color: white;
    position: absolute;
    top: 50px;
    z-index: 999;
    box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.2);

    .websitebox_search_top {
      line-height: 33px;
      width: 100%;
      border-bottom: 1px solid #d8d8d8;
      box-sizing: border-box;
      padding: 0px 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .websitebox_search_body {
      position: relative;
      width: 100%;
      height: 200px;
      overflow: auto;
      box-sizing: border-box;
      padding-left: 10px;
      padding-top: 16px;

      .websitebox_search_body_right {
        width: 64%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        border-left: 1px solid #d8d8d8;
        box-sizing: border-box;
        padding-left: 10px;
        padding-top: 16px;
        overflow: auto;
      }
    }
  }
}

.websitebox {
  position: relative;

  .loadingWiat {
    margin-left: 15px;
  }

  .websitebox_search {
    min-width: 240px;
    height: 250px;
    background-color: white;
    position: absolute;
    top: 50px;
    z-index: 999;
    box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.2);

    .websitebox_search_top {
      line-height: 33px;
      width: 100%;
      border-bottom: 1px solid #d8d8d8;
      box-sizing: border-box;
      padding: 0px 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .websitebox_search_body {
      width: 100%;
      height: 200px;
      overflow: auto;
      box-sizing: border-box;
      padding-left: 10px;
      padding-top: 16px;
    }
  }
}

.warningRules {
  width: 100%;
  margin-bottom: 20px;

  .warningRules_words {
    display: flex;

    .warningRules_span {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      position: relative;
      top: 5px;
      flex-shrink: 0;
      width: 73px;
    }

    .warningRules_words_content {
      display: flex;
      flex-wrap: wrap;
    }
  }
}

.navcolor {
  color: #2e59ec;
}

::v-deep.el-checkbox {
  margin-right: 16px;
}

.el-checkbox {
  // margin-bottom: 12px;
}

.warningRules_tag {
  margin-right: 15px;
  font-size: 14px;
  margin-bottom: 10px;
  background-color: #f5f7fb;
  border-radius: 3px;
  padding: 2px 3px 3px 10px;
  line-height: 24px;
  color: #555;
}

.warningRules_tag span {
  font-size: 14px;
  vertical-align: middle;
  color: #c44d66;
  margin-left: 5px;
  cursor: pointer;
}

.prohibit {
  cursor: not-allowed;
}

.type {
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  border-radius: 1px;
  height: 24px;
  padding: 0 5px;
  font-weight: bold;
  line-height: 24px;
  // margin-right: 14px;
}

.tonalityInputList {
  display: flex;
  align-items: center;
}

.tonalityInputList-name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  width: 70px;
  margin-top: 16px;
}

.tonalityInputList-tab {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 500px;
}

.tonalityInputList-col {
  padding: 6px 8px;
  background: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  color: #333333;
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-left: 16px;

  img {
    margin-left: 3px;
    cursor: pointer;
  }
}

.tonality-content {
  background-color: #f4f5fa;
  padding: 16px;
}

.tonality-tab {
  padding: 6px 8px;
  background: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  color: #333333;
  cursor: pointer;
}

.tonality-tab.active {
  background: #2e59ec;
  color: #fff;
}

.tonality-tab:hover {
  color: #2e59ec;
}

.tonality-tab.active:hover {
  color: #ffffff;
}

.tonality-tab+.tonality-tab {
  margin-left: 16px;
}

.dialogcenter-content-left {
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}

.inspect-expression {
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 14px;
  color: #2e59ec;
  cursor: pointer;
}

.comment-box-yujing {
  height: 24px;
  line-height: 24px;
  margin-left: 16px;
  padding: 0px 8px;
  font-size: 14px;
  font-weight: bold;
  background: #ffedef;
  color: #ea3342;
}

.history-style {
  color: #fff;
  background-color: #fbcc50 !important;
}

.repeat-style {
  color: #fff;
  background-color: #e6a23c !important;
}

.is-warn-style {
  min-width: 62px;
}
</style>
